import { Component, Input, ElementRef, SimpleChanges, OnDestroy, Output, EventEmitter } from '@angular/core';

@Component({
  selector: 'datatable',
  template: ""
})
export class WebixDatatablecomponent implements OnDestroy {
  private ui: webix.ui.datatable;
  data: any[] = [];
  @Input() monthData: any[] = [];
  @Input() newDateArray: any[] = [];
  @Input() gridWidth: number = 750;
  @Output() selectedData = new EventEmitter<any[]>();

  constructor(private root: ElementRef) {
    this.ui = <webix.ui.datatable>webix.ui({
      view: "datatable",
      container: root.nativeElement,
      id: "timeoffGrid",
      columns: this.newDateArray,
      data: this.monthData,
      autoheight: true,
      minWidth: 300,
      maxWidth: 750,
      scroll: "x",
      leftSplit: 1,
      onClick: {
        "load": (event, id) => {
          setTimeout(() => {
            var temp = (<webix.ui.datatable>webix.$$("timeoffGrid")).getItem(id.row);
            var data = temp[id.column].split("|")
            this.data = [];
            for (var i = 1; i < data.length; i++) {
              this.data[data[i]] = data[i + 1];
              i++;
            }
            this.selectedData.emit(this.data);
          });
        }
      }
    });
  }

  ngOnInit() {
    this.reSize();
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (this.ui) {
      (<webix.ui.datatable>webix.$$("timeoffGrid")).clearAll();
      if (this.monthData != undefined && this.monthData != []) {
        this.ui.parse(this.monthData, "json");
      }
      if (this.newDateArray != undefined && this.newDateArray != []) {
        (<webix.ui.datatable>webix.$$("timeoffGrid")).config.columns = this.newDateArray;
        (<webix.ui.datatable>webix.$$("timeoffGrid")).refreshColumns();
      }
    }
  }

  ngOnDestroy() {
    if (this.ui) {
      this.ui.destructor();
    }
  }

  reSize() {
    this.ui.config.width = this.gridWidth;
    (<webix.ui.datatable>webix.$$("timeoffGrid")).resize();
  }
}